import { Injectable } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as actions from './../store/feed-profit.actions';

@Injectable()
export class FeedProfitOverviewResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(actions.loadData());
    return of(true);
  }
}
